
document.querySelectorAll('.promo-video-wrapper').forEach((videoWrap) => {
  videoWrap.addEventListener('click', () => {
    document.querySelector('#videoPopup-video').setAttribute('src', videoWrap.getAttribute('data-src') + '?rel=0&amp;showinfo=0&amp;modestbranding=1&amp');
  })
  videoWrap.addEventListener('keydown', (e) => {
    if (e.keyCode == 13) {
      e.preventDefault();
      document.querySelector('#videoPopup-video').setAttribute('src', videoWrap.getAttribute('data-src') + '?rel=0&amp;showinfo=0&amp;modestbranding=1&amp');

      setTimeout(() => {
        document.querySelector('#videoPopup').modal();
      }, 300);
    }

  })
});

/* Assign empty url value to the iframe src attribute when
modal hide, which stop the video playing */
document.querySelector('#videoPopup').addEventListener('hide.bs.modal', function () {
  document.querySelector('#videoPopup-video').setAttribute('src', '');
});
